/* eslint-disable react/no-danger */
import DOMPurify from 'dompurify';
import { Typography } from '@mui/material';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './UnitGuideSection.scss';

const defaultProps = {
  title: '',
  children: null,
  content: null,
  className: '',
};

const UnitGuideSection = (props) => {
  const { title, className, content, children } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className={`unit-guite-section ${className}`}>
      {title && (
        <Typography variant='h6' className='unit-guide-section-title'>{title}</Typography>
      )}
      <div className='unit-guide-section-body'>
        {children}
        {content && (
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
        )}
      </div>
    </div>
  );
};

export default UnitGuideSection;
